export const ActionTypes = {
  LOADING: "GET_OPTION_LOADING",
  ERROR: "GET_OPTION_ERROR",
  SUCCESS: "GET_OPTION_SUCCESS",
};
